import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';



@Component({
    selector: 'app-spinner',
    templateUrl: '../templates/template1/views/spinner.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/spinner.component.less'
    ],
})
export class SpinnerComponent implements OnInit, OnDestroy {
    @Input() spinnerName: string;
    showSpinner = false;
    constructor(private spinnerService: SpinnerService) {

    }
    ngOnInit(): void {
        this.registerSpinner();
    }
    registerSpinner() {
        this.spinnerService.listenloader(this.spinnerName).subscribe((show: boolean) => {
        this.showSpinner = show;
        });
    }

    ngOnDestroy(): void {
        this.spinnerService.unsubscribeListener(this.spinnerName);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/spinner.component.ts